import { useState } from 'react';

import PropTypes from 'prop-types';

import TextInput from '#globalComponents/Forms/TextInput';
import Menu from '#globalComponents/Overlay/Menu';
import Panel from '#globalComponents/Overlay/Panel';
import Popover from '#globalComponents/Overlay/Popover';

import { formatPrice } from '../../../utils/formatters';

const ProductSearchDropdown = ({ allProducts, allBundles, value, onChange, excludeIds }) => {
	const [search, setSearch] = useState('');
	const [open, setOpen] = useState(false);

	const selectedProduct = allProducts.find((p) => p.id === value?.productId);
	const selectedBundle = allBundles.find((b) => b.id === value?.bundleId);
	const selectedLabel = selectedProduct?.name ?? selectedBundle?.name ?? '';

	const term = search.toLowerCase();
	const filteredProducts = allProducts.filter(
		(p) =>
			!excludeIds.has(p.id) &&
			(p.name.toLowerCase().includes(term) || (p.articleNumber ?? '').toLowerCase().includes(term)),
	);
	const filteredBundles = allBundles.filter((b) => !excludeIds.has(b.id) && b.name.toLowerCase().includes(term));

	const close = () => {
		setOpen(false);
		setSearch('');
	};

	const select = (type, id) => {
		onChange(type === 'product' ? { productId: id, bundleId: '' } : { productId: '', bundleId: id });
		close();
	};

	const trigger = (
		<TextInput
			value={open ? search : selectedLabel}
			onChange={(e) => {
				setSearch(e.target.value);
				setOpen(true);
			}}
			onFocus={() => setOpen(true)}
			placeholder="Produkt oder Paket suchen..."
		/>
	);

	return (
		<Popover open={open} onClose={close} trigger={trigger} align="stretch">
			<Panel.Body padded={false}>
				<Menu>
					{filteredProducts.length > 0 && (
						<>
							<Menu.Label>Produkte</Menu.Label>
							{filteredProducts.map((p) => (
								<Menu.Item
									key={p.id}
									onClick={() => select('product', p.id)}
									trailing={p.price !== null ? formatPrice(p.price) : undefined}
								>
									{p.articleNumber && (
										<span className="font-mono text-bgBase-800 mr-1.5">{p.articleNumber}</span>
									)}
									{p.name}
								</Menu.Item>
							))}
						</>
					)}
					{filteredBundles.length > 0 && (
						<>
							<Menu.Label>Pakete</Menu.Label>
							{filteredBundles.map((b) => (
								<Menu.Item
									key={b.id}
									onClick={() => select('bundle', b.id)}
									trailing={b.price !== null ? formatPrice(b.price) : `${b.items?.length ?? 0} Pos.`}
								>
									{b.name}
								</Menu.Item>
							))}
						</>
					)}
					{filteredProducts.length === 0 && filteredBundles.length === 0 && (
						<Menu.Empty>Keine Ergebnisse</Menu.Empty>
					)}
				</Menu>
			</Panel.Body>
		</Popover>
	);
};

ProductSearchDropdown.propTypes = {
	allProducts: PropTypes.array.isRequired,
	allBundles: PropTypes.array.isRequired,
	value: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	excludeIds: PropTypes.instanceOf(Set).isRequired,
};

export default ProductSearchDropdown;
